<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="tableAdd">创建</a-button>
      </a-col>
      <!--<a-col :span="5">-->
      <!--<a-input placeholder="权限组名字" v-model="keywords" @keyup.enter="tableSearch">-->
      <!--<a-icon slot="suffix" type="search"></a-icon>-->
      <!--</a-input>-->
      <!--</a-col>-->
    </a-row>
    <a-divider></a-divider>
    <div>
      <!--  <div style="padding-bottom: 20px;">
                  <a-radio-group default-value="a" button-style="solid" v-model="b">
                    <a-radio-button value="a">
                     启用
                    </a-radio-button>
                    <a-radio-button value="b">
                      已禁用
                    </a-radio-button>
                    <a-radio-button value="c">
                      全部
                    </a-radio-button>
                  </a-radio-group>
                </div> -->

      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="username" title="权限组名字" data-index="name" />
        <a-table-column width="100px" key="status" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="180px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1 })" class="active_btn" size="small"
              type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0 })" class="active_btn" size="small"
              type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <a-dropdown :trigger="['click']" v-if="item.status == 1">
              <a-button size="small" type="link" icon="more" />
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="setRule({ role_id: item.id })">设置角色权限</a>
                </a-menu-item>
              </a-menu>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="tableDel({ ids: item.id })">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="角色" @ok="modalSave" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-tree-select v-model="form.pid" style="width: 100%" :tree-data="this.data"
            :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }" placeholder="选择父角色,不选为最高角色"
            tree-default-expand-all @change="selectItem" allowClear></a-tree-select>
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.name" placeholder="角色名字" />
        </a-form-item>


        <a-form-item v-if="userinfo.type > 10">
          指定部门： <a-switch v-model="form.is_assign" />
        </a-form-item>

        <a-form-item v-if="form.is_assign">
          可管理校区：<a-select v-model="form.assign_campusids" mode="multiple" placeholder="选择指定校区" style="width: 100%"
            @change="changecampus">
            <a-select-option v-for="item in campuslist" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>

    </a-modal>
    <a-modal :maskClosable="false" :visible="rule_visible" title="设置角色权限" @ok="modalSaveRule" @cancel="modalCancel">
      <a-form>
        <a-form-item>
          <a-form-item>
            <a-input v-model="authform.role_id" type="hidden" />
          </a-form-item>
          <a-tree-select v-model="authform.rule_id" style="width: 100%" :treeData="ruleList"
            :replaceFields="{ children: 'children', title: 'title', key: 'id', value: 'id' }" placeholder="选择角色的权限"
            tree-default-expand-all @change="selectRuleItem" allowClear treeCheckStrictly treeCheckable></a-tree-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
//角色管理
export default {
  components: { AFormItem },
  data() {
    return {
      keywords: "",
      data: [],
      userinfo: [],
      pageinfo: { total: 1, current: 1, pageSize: 10, allCnt: 0 },
      loading: false,
      visible: false,
      rule_visible: false,
      form: {
        is_assign: false,
        assign_campusids: [],
      },
      campuslist: {},
      authform: { rule_id: "", role_id: "" },
      ruleList: []
    };
  },
  mounted() {
    this.tableSearch();
    this.getinfo();
    this.getcampuslist();

  },

  methods: {
    selectItem(pid) {
      this.form.pid = pid;
    },
    getinfo() {
      this.$axios
        .post("/api/Admin/get_user_info")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.userinfo = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    changecampus() {

    },
    // 获取校区列表
    getcampuslist() {
      this.$axios
        .post("/api/admin/getmycampuslist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campuslist = res.data;
            //this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    changeStatus(data) {
      this.$axios
        .post("/api/AuthRole/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    onPaginationChange() {
      this.getTableList({ keyword: this.keywords });
    },
    tableSearch() {
      this.getTableList({ keyword: this.keywords });
    },
    getTableList(data) {
      this.$axios
        .post("/api/AuthRole/index", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableEdit(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.pid = item.pid;
      if (item.is_assign === 1) {
        this.form.is_assign = true;
      }
      else {
        this.form.is_assign = false;
      }

      if (item.assign_campusids != null) {
        this.form.assign_campusids = item.assign_campusids.split(',');
      }
      else {
        this.form.assign_campusids = [];
      }

      this.visible = true;
    },

    tableAdd() {
      this.form = {};
      this.visible = true;
    },
    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/AuthRole/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getTableList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },

    modalSave() {
      let url = "/api/AuthRole/edit";
      if (!this.form.id) {
        url = "/api/AuthRole/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
            this.visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalCancel() {
      this.visible = false;
      this.rule_visible = false;
    },
    selectRuleItem(ids) {
      console.info(ids);
      this.authform.rule_id = ids;
    },

    setRule(data) {
      this.authform.role_id = data.role_id;
      if (this.ruleList.length == 0) {
        this.$axios
          .post("/api/AuthRole/getroleruletree")
          .then(res => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定"
              });
            } else {
              console.info("rule LIST:", res.data);
              this.ruleList = res.data;

            }
          })
          .catch(err => {
            console.error(err);
          });
      }

      this.$axios
        .post("/api/AuthRole/getrolerule", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.authform.rule_id = [];
            for (let i = 0; i < res.data.length; i++) {
              this.authform.rule_id.push({ name: res.data[i]["title"], value: res.data[i]["rule_id"] });
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
      this.rule_visible = true;
    },
    modalSaveRule() {
      let data = JSON.parse(JSON.stringify(this.authform));
      if (data.rule_id.length == 0) {
        this.$error({
          title: "错误",
          content: "至少选一个权限",
          okText: "确定"
        });
        return false;
      }
      data.rule_id = [];
      for (let i = 0; i < this.authform.rule_id.length; i++) {
        data.rule_id.push(this.authform.rule_id[i]['value']);
      }
      this.$axios
        .post("/api/AuthRole/boundrule", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.rule_visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>